import { render, staticRenderFns } from "./BuyDialog.vue?vue&type=template&id=1f53d0d8&scoped=true&"
import script from "./BuyDialog.vue?vue&type=script&lang=js&"
export * from "./BuyDialog.vue?vue&type=script&lang=js&"
import style0 from "./BuyDialog.vue?vue&type=style&index=0&id=1f53d0d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f53d0d8",
  null
  
)

export default component.exports